import { useObservable } from '@hooks/useObservable';

import { authStore } from './authStore';

export const useAuth = () =>
  useObservable(() => ({
    isAuthenticated: authStore.isAuthenticated,
    canAuthenticate: authStore.canAuthenticate,
  }));
